import React, { useEffect, useState, useRef } from 'react';
import useAuth from '../../component/useAuth';
import Template from '../../component/Template';
import Api from '../../component/Api';
import { useDownloadExcel } from 'react-export-table-to-excel';
import { useNavigate } from 'react-router-dom';
import { useParams, Navigate } from 'react-router-dom';

export default function Viewlog() {
  const [userlog, setUserLogData] = useState([]);
  const tableRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  let { id } = useParams();
  const decodedID = atob(id);

  const isAuth = useAuth()
  const navigate = useNavigate();
  if (isAuth === false) {
    navigate("/admin/")
  }

  const [totalviewlog, setTotalViewLog] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredAndSortedData, setfilteredAndSortedData] = useState([]);

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const [message, setMessage] = useState("");

  const [sortBy, setSortBy] = useState({ column: null, direction: 'asc' }); //sort05/03/2024

  const [username, setUsername] = useState("");

  // Function to handle sorting-sort05/03/2024
  const handleSort = (column) => {
    const newSortBy = {
      column,
      direction: sortBy.column === column && sortBy.direction === 'asc' ? 'desc' : 'asc',
    };
    setSortBy(newSortBy);
  };

  // Sort userlog based on sortBy state-sort05/03/2024
  const sortedUserLog = [...userlog].sort((a, b) => {
    if (sortBy.direction === 'asc') {
      return a[sortBy.column] > b[sortBy.column] ? 1 : -1;
    } else {
      return a[sortBy.column] < b[sortBy.column] ? 1 : -1;
    }
  });
  // Function to render sort icon-sort05/03/2024
  const renderSortIcon = (columnName) => {
    if (sortBy.column === columnName) {
      return sortBy.direction === 'asc' ? <i className="fa fa-sort-up ml-1" aria-hidden="true"></i> : <i className="fa fa-sort-down ml-1" aria-hidden="true"></i>;
    }
    return <i className="fa fa-sort ml-1" aria-hidden="true"></i>; // Show disabled sort icon
  };

  const [showAlert, setShowAlert] = useState(false);

  const handleClose = () => {
    setShowAlert(false);
  };




  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hour = String(date.getHours()).padStart(2, '0');
    const minute = String(date.getMinutes()).padStart(2, '0');
    return `${day}/${month}/${year}, ${hour}:${minute}`;
  }


  useEffect(() => {
    fetchData();
  }, [currentPage, decodedID, startDate, endDate]);



  const fetchData = async () => {
    try {
      const id1 = decodedID;
      const { http } = Api();
      const formattedDate = new Date().toISOString().split('T')[0];

      if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
        console.error('Start date cannot be greater than end date');
        setShowAlert(true);
        setMessage("Start date cannot be greater than end date");
        setUserLogData([]); // Clear user log data
        setTotalPages(0);
        return; // Do not make API call if validation fails
      }
      else if (new Date(startDate) > new Date() || new Date(endDate) > new Date()) {
        setShowAlert(true);
        setMessage('Start date or end date cannot be greater than today');
        setUserLogData([]); // Clear user log data
        setTotalPages(0);
        return; // Do not make API call if validation fails
      }

      setShowAlert(false);

      const response = await http.get(`/Admin/getuserlog?page=${currentPage}`, {
        params: {
          id: id1,
          start_date: startDate || '2020-02-20',
          end_date: endDate || formattedDate,
          limit: '50',
        }
      });
      setUserLogData(response.data.data);
      setTotalViewLog(response.data.total);

      //console.log("total page"+response.data.total);
      if (response.data.total === 0) {

        Navigate('/admin/users');
      }
      setTotalPages(Math.ceil(response.data.total / 50));
    } catch (error) {
      console.error('Error fetching user log data:', error);
      setTotalPages(0);
    }
  };



  /*useEffect(() => {
    const fetchData = async () => {
      try {
        const id1 = decodedID;
        const { http } = Api();
        const formattedDate = new Date().toISOString().split('T')[0];
        const response = await http.get(`/Admin/getuserlog?page=${currentPage}`, {
          params: {
            id: id1,
            start_date: '2023-02-20',
            end_date: formattedDate,
            limit: '50',
          }
        });
        setUserLogData(response.data.data);
        setTotalPages(Math.ceil(response.data.total / 50));

      } catch (error) {
        console.error('Error fetching user log data:', error);
      }
    };

    fetchData();


  }, [currentPage, decodedID]);*/



  const handleExportDropdownToggle = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue === "1") {
    } else if (selectedValue === "2") {
    } else if (selectedValue === "3") {
      onDownload();
    }
  };

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: 'User Log',
    sheet: 'Log',
  });

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [showFilter, setShowFilter] = useState(false); // State to control filter section visibility
  const toggleFilter = () => {
    setShowFilter(!showFilter); // Toggle filter section visibility
  };

  const closeFilter = () => {
    setShowFilter(false); // Close filter section
  };

  const handleSearchInputChange = (event) => {
    //console.log(event.target.value+"onchange");
    setSearchQuery(event.target.value);
  };

  //20/3/2024
  useEffect(() => {
    const access = async () => {
      const { http } = Api();
      const id1 = decodedID;
      try {
        const response = await http.get(`/getuserlistbyID/${id1}`);
        setUsername(response.data.name)
        console.log("Response Data:", response.data.name);

      } catch (error) {
        console.error("Error fetching user roles:", error);

      }
    };
    access();
  }, []);

  const [ismobile, setIsmobile] = useState(false);
  const togglemenu = () => {
    setIsmobile(!ismobile);
  };


  return (
    <Template>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header card-heading">
                <div className="py-3 d-flex justify-content-between align-items-center">
                  <h5 className="lbl1">{username}</h5>
                  <div className="d-flex ml-auto">
                    {/* Responsive Dropdown or Hamburger Menu */}
                    <div className="dropdown d-lg-none">
                      <button
                        className="btn btn-light dropdown-toggle"
                        type="button"
                        id="mobileActionsDropdown"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded={ismobile}
                        onClick={togglemenu}
                      >
                        <i className="fas fa-bars"></i>
                      </button>
                      <div
                        className={`dropdown-menu dropdown-menu-right ${ismobile ? 'show' : ''}`}
                        aria-labelledby="mobileActionsDropdown"
                        style={{
                          margin: '10px 20px 20px -60px',
                          boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
                          borderRadius: '0.5rem',
                          overflow: 'hidden',
                          color: 'black',
                        }}
                      >
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            toggleFilter();
                            togglemenu();
                          }}
                        >
                          <i
                            className={`bi ${showFilter ? 'bi-x-circle-fill' : 'bi-funnel-fill'} show`}
                            aria-hidden="true"
                            style={{ cursor: "pointer", color: 'black' }}
                          > Filter</i>
                        </a>
                        <div className="dropdown-divider my-0"></div>
                        <div className="dropdown-item py-3">
                          <select
                            className="form-select btn-border"
                            id="inputGroupSelect01"
                            onChange={handleExportDropdownToggle}
                            style={{ cursor: "pointer" }}
                          >
                            <option selected="">Export As</option>
                            <option value="1">Pdf</option>
                            <option value="2">Csv</option>
                            <option value="3">Excel</option>
                          </select>
                        </div>

                      </div>
                    </div>


                    {/* Desktop View */}
                    <div className="d-none d-lg-flex">
                      <div className="light-box">
                        <a style={{ marginLeft: "10px" }} onClick={toggleFilter} className="btn btn-light">
                          <i className={`fa fa-filter ${showFilter ? 'icon-close' : 'filter-icon'} show`} aria-hidden="true"></i>
                        </a>
                        &nbsp;&nbsp;
                      </div>
                      <div className="form-group">
                        <select className="form-select btn-border" id="inputGroupSelect01" onChange={handleExportDropdownToggle} style={{ cursor: "pointer" }}>
                          <option selected="">Export As</option>
                          <option value="1">Pdf</option>
                          <option value="2">Csv</option>
                          <option value="3">Excel</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={`collapse ${showFilter ? 'show' : ''}`} id="collapseProduct">
                <div className="card card-body list-product-body">
                  <div className="row row-cols-xl-5 row-cols-lg-4 row-cols-md-3 row-cols-sm-2 row-cols-2 g-3">
                    <div className="col">
                      <label >Start Date</label>
                      {/*05-03-2024minandmaxdatesfromuserlogdata */}
                      <input className="form-control digits" type="date" onChange={(e) => setStartDate(e.target.value)} />
                    </div>
                    <div className="col">
                      <label >End Date</label>
                      {/*05-03-2024minandmaxdatesfromuserlogdata */}
                      <input className="form-control digits" type="date" onChange={(e) => setEndDate(e.target.value)} />
                    </div>

                    <div className="col align-self-end">


                    </div>


                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-md-12" style={{ width: "98%" }}>
                      {showAlert && (



                        <div class="alert alert-danger dark alert-dismissible fade show" role="alert"><i data-feather="heart"></i>
                          <p style={{ textAlign: 'center', textJustify: 'auto' }}>{message}</p>
                          <button class="btn-close" type="button" onClick={handleClose} data-bs-dismiss="alert" aria-label="Close"></button>
                        </div>
                      )}

                      



                      <div className="table-responsive ovrflw" style={{ msOverflowX: "auto" }}>
                        <div className='row'>
                          <div className='col-md-6 wdt' ><p>Showing {userlog.length} of {totalviewlog} records </p> {/* Displaying total number of records */}</div>
                          <div className='col-md-6 wdt' align='right'>
                            <input
                              type="text"
                              value={searchQuery}
                              onChange={handleSearchInputChange}
                              placeholder="Search..."
                              className='form-control'
                              style={{ width: '300px' }}
                            /></div></div>
                        <table className="display dataTable table-striped table-bordered" id="dataTable" style={{ tableLayout: "fixed" }} ref={tableRef}>
                          <thead>
                            <tr className="bg-primary">
                              {/*-sort05/03/2024-start*/}

                              <th onClick={() => handleSort('created_at')}>
                                Date &nbsp;
                                {renderSortIcon('created_at')}
                              </th>
                              <th onClick={() => handleSort('ip_address')}>
                                IP Address&nbsp;
                                {renderSortIcon('ip_address')}
                              </th>
                              <th onClick={() => handleSort('user_action')}>
                                Action&nbsp;
                                {renderSortIcon('user_action')}
                              </th>
                            </tr>
                          </thead>

                          {totalPages > 0 ? (
                            <tbody>
                              {sortedUserLog.map((log, index) => (
                                <tr key={index}>
                                  <td>{formatDate(log.created_at)}</td>
                                  <td>{log.ip_address}</td>
                                  <td>{log.user_action}</td>
                                </tr>
                              ))}  {/*-sort05/03/2024-end*/}
                            </tbody>) : (
                            <tbody>
                              <tr>
                                <td colSpan="3" align='center'>No Log Data Available</td>
                              </tr>
                            </tbody>
                          )
                          }
                        </table>
                      </div>
                      {totalPages > 1 && (
                        <nav aria-label="..." style={{ cursor: "pointer" }}>
                          <ul className="pagination justify-content-center">
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                              <span className="page-link pgn-clr" onClick={handlePreviousPage}><i class="bi bi-arrow-left-circle-fill"></i></span>
                            </li>
                            <li className={`page-item`}>
                              <span className="page-link pgn-clr" onClick={() => handlePageChange(1)}>1</span>
                            </li>
                            {currentPage > 4 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}
                            {[...Array(totalPages - 1).keys()].slice(currentPage > 4 ? currentPage - 3 : 1, currentPage + 2).map((pageNumber) => (
                              <li key={pageNumber} className={`page-item ${pageNumber + 1 === currentPage ? 'act-clr' : ''}`}>
                                <span className="page-link pgn-clr" onClick={() => handlePageChange(pageNumber + 1)}>{pageNumber + 1}</span>
                              </li>
                            ))}
                            {currentPage < totalPages - 3 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}

                            <li className={`page-item`}>
                              <span className="page-link pgn-clr" onClick={() => handlePageChange(totalPages)}>{totalPages}</span>
                            </li>

                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                              <span className="page-link pgn-clr" onClick={handleNextPage}><i class="bi bi-arrow-right-circle-fill"></i></span>
                            </li>
                          </ul>
                        </nav>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div></div></div>
    </Template>

  );
}